import { DataLayer } from '../types/data-layer.type';
import { InjectionToken, inject } from '@angular/core';
import { NGX_WINDOW } from './ngx-window-token';
import { CustomWindow } from '../types/custom-window.type';

/**
 * Check if there is some global function called gtag on Window object, or create an empty function to doesn't brake codes...
 */
export function getDataLayerFn(window: CustomWindow | null): DataLayer | null {
  return window ? (window.dataLayer = window.dataLayer || []) : null;
}

/**
 * Provides an injection token to access Google Analytics DataLayer Collection
 */
export const NGX_DATA_LAYER = new InjectionToken<DataLayer | null>('ngx-data-layer', {
  providedIn: 'root',
  factory: () => getDataLayerFn(inject(NGX_WINDOW)),
});
